import BaseTemplate from '@/kyna/layouts/BaseTemplate';
import DonationsView from '@/kyna/view/_public/Donations';

export default function Donations() {
  return (
    <BaseTemplate title="Donations" body={<DonationsView />} />
  )
}
